exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.slotEditor .dropdownWrapper {\n  width: 100%;\n  min-width: 96px;\n  position: relative;\n}\n\n.slotEditor .dropdownWrapper .dropdown {\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n  box-shadow: 0 2px 8px 0 #eaeaea;\n  position: absolute;\n  width: 100%;\n}\n\n.slotEditor .ba-common-accordionItem__collapse .ReactCollapse--content {\n  overflow-x: inherit;\n  overflow-y: inherit;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-1!./node_modules/postcss-loader??ref--1-2!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js??ref--1-4!./src/stylesheets/fieldDropdown.scss
// module id = 47
// module chunks = 0